import { createComponentHost } from "./componentHost"
import { DialogHeaderCtrl } from "./dialogHeader"
import { createMsgbox, createMsgboxWithTmpl } from "./msgbox/msgbox"
import { ShellService } from "./shell"

/// <reference path="types.ts" />
/// <reference path="shell.ts" />
/// <reference path="module.ts" />
/// <reference path="componentContext.ts" />
/// <reference path="component.ts" />
/// <reference path="componentHost.ts" />
/// <reference path="dialog.ts" />

/// <reference path="msgbox/msgbox.ts" />

export function setupShell(module: ng.IModule) {

    module

        .service("OmniaShell", ShellService)

        .directive("omniaShellComponentHost", createComponentHost)
        .directive("omniaShellMsgbox", createMsgbox)
        .directive("omniaShellMsgboxTmpl", createMsgboxWithTmpl)
        .directive("omniaDialogHeader", DialogHeaderCtrl.create)


}
